import { useMemo } from 'react';
import { HubBasePage } from '../../../../../types';
import {
  DiscoveryContentTypes,
  InformaMetaTagPageType,
} from '../../../../../constants';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubPage } from '../../store/features/page';
import { selectBrandHubOptions } from '../../store/features/options';
import {
  selectHubDiscoveryFacets,
  selectHubDiscoverySiteRecord,
  DiscoverySite,
  HubPageNames,
  SortTypes,
} from '../../../../../store/features/discovery';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import { SiteCard } from '../../../shared/productFilter/cards';
import { AggregatedProductPage } from '../../../shared/siteBuilder/AggregatedProductPage';

export function Events() {
  const {
    data: {
      page: {
        details: { title, description, metaDescription, searchQueryData },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectBrandHubPage<HubBasePage>());
  const {
    data: { name: hubName, subBrandName: brandName },
  } = useRootSelector(selectBrandHubOptions);
  const facets = useRootSelector(selectHubDiscoveryFacets);
  const record = useRootSelector((state) =>
    selectHubDiscoverySiteRecord(state, DiscoveryContentTypes.EVENT),
  );

  const heading = title || 'Events';

  const availableSubBrands = useMemo(() => {
    const { facetsConfig, subBrands: brands = [] } = searchQueryData;

    if (facetsConfig?.subBrandsEnabled) {
      return brands;
    }

    return [brandName];
  }, [brandName, searchQueryData]);

  const defaultValues = useMemo(
    () => ({
      deliveryType: [],
      subBrands: availableSubBrands,
      sectors: [],
      topics: [],
      month: [],
      location: [],
      availableSubBrands,
      requestedSortType: SortTypes.FEATURED,
      page: 1,
      count: 20,
      searchInput: '',
      type: [DiscoveryContentTypes.EVENT],
    }),
    [availableSubBrands],
  );

  return (
    <PageLayout>
      <MetaTags
        informaPageType={InformaMetaTagPageType.BasePage}
        informaPageId={HubPageNames.events}
        thumbnail={brandLogo?.path}
        description={metaDescription}
        titleSuffix={hubName}
        title={heading}
      />
      <AggregatedProductPage<DiscoverySite>
        searchQueryData={searchQueryData}
        defaultValues={defaultValues}
        renderProduct={(product) => <SiteCard cardType="list" data={product} />}
        record={record}
        facets={facets}
        subtitle={description}
        title={heading}
        contentType={DiscoveryContentTypes.EVENT}
        pageName={HubPageNames.events}
      />
    </PageLayout>
  );
}
